module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/256-georgia-9502ed7fe4e25111282575f430c15ee7.svg";